import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Calculator, TrendingUp } from 'lucide-react';
import { DashboardHeader } from '../Dashboard/DashboardUi';
import { useAuth } from '../../context/AuthContext';
import { ChallengesCommerciaux } from './ChallengesCommerciaux';
import { useMoiCommerciaux } from './useMoiCommerciaux';

/**
 * Accueil d'un compte commercial (2026-10-23, Emeni) : uniquement ce qui sert son travail. Le parcours d'un devis : une estimation
 * (jamais un devis direct, un commercial peut se tromper), puis « Établir officiellement le devis » une fois le prix validé avec le client,
 * signature sur place ou envoi par e-mail, et rendez-vous à fixer si le client signe. En dessous : le challenge du moment (top 3 et son rang).
 */
const Raccourci: React.FC<{ to: string; icone: React.ReactNode; titre: string; texte: string }> = ({ to, icone, titre, texte }) => (
    <Link to={to} className="group flex min-w-0 items-start gap-3 rounded-xl border border-border bg-surface px-4 py-3.5 transition-colors hover:border-brand-600/50">
        <span className="mt-0.5 shrink-0 text-brand-600 dark:text-brand-400">{icone}</span>
        <span className="min-w-0">
            <span className="block text-[13.5px] font-semibold text-content">{titre}</span>
            <span className="block text-[12px] text-content-muted">{texte}</span>
        </span>
    </Link>
);

export const AccueilCommercial: React.FC = () => {
    const { user } = useAuth();
    const { moi } = useMoiCommerciaux();
    const prenom = String(moi?.commercial?.nom || user?.name || '').split(' ')[0];
    return (
        <div className="space-y-4 max-w-[1180px]">
            <DashboardHeader societe={(user as any)?.company_name || ''} titre="Mon accueil"
                sousTitre={prenom ? `Bonjour ${prenom}. Tout ce qu'il vous faut pour vos clients, au même endroit.` : 'Tout ce qu\'il vous faut pour vos clients, au même endroit.'} />
            {moi?.commercial?.code_vendeur && (
                <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-xl border border-brand-600/30 bg-brand-600/10 px-4 py-3 text-[12.5px] text-content">
                    <span>Votre code vendeur <span className="ml-1.5 rounded-md bg-surface px-2 py-1 font-mono text-[15px] font-semibold text-content">{moi.commercial.code_vendeur}</span></span>
                    <span className="text-content-muted">Il figure sur vos devis, y compris ceux envoyés par e-mail.</span>
                </div>
            )}
            <div className="grid gap-3 grid-cols-1 md:grid-cols-3">
                <Raccourci to="/estimation-devis" icone={<Calculator size={20} />} titre="Nouvelle estimation" texte="Chiffrez avec le client, puis établissez le devis une fois le prix validé." />
                <Raccourci to="/suivi-prestation" icone={<Briefcase size={20} />} titre="Mes clients" texte="Vos dossiers : devis envoyés, signés, rendez-vous à fixer." />
                <Raccourci to="/commerciaux" icone={<TrendingUp size={20} />} titre="Mes ventes" texte="Vos devis signés et vos commissions." />
            </div>
            <ChallengesCommerciaux direction={false} />
        </div>
    );
};

export default AccueilCommercial;
